module.exports = __webpack_public_path__ + "img/autospin_btn.fa296053.png";